import { Box } from '@chakra-ui/react';
import React from 'react';

const Card = props => {
  const { children, ...rest } = props;
  return (
    <Box bg={'white'} rounded={'lg'} px={{ base: 4, md: 6 }} py={{ base: 4, md: 6 }} w="full" {...rest}>
      {children}
    </Box>
  );
};

export default Card;
